"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const react_redux_1 = require("react-redux");
const react_router_dom_1 = require("react-router-dom");
const redux_1 = require("redux");
const config_1 = require("config");
const AccountCard_1 = __importDefault(require("../account_lookup/components/AccountCard"));
const reducer_1 = require("../reducer");
function AccountExists({ applicationInfo, approvedCreditApplication, currentLocation, }) {
    const history = (0, react_router_dom_1.useHistory)();
    if (!applicationInfo) {
        history.push(config_1.START_APPLICATION_URL);
        return (0, jsx_runtime_1.jsx)(jsx_runtime_1.Fragment, {});
    }
    const account = {
        division: '',
        serviceDate: '',
        availableCreditLimit: 0,
        ...approvedCreditApplication,
    };
    const { firstName, lastName } = applicationInfo;
    account.name = {
        firstName,
        lastName,
    };
    return ((0, jsx_runtime_1.jsx)(jsx_runtime_1.Fragment, { children: (0, jsx_runtime_1.jsxs)("div", { className: "account-lookup m-t-30", style: { margin: '0 auto', marginTop: '30px' }, children: [(0, jsx_runtime_1.jsx)("h1", { children: "Existing Account Found" }), (0, jsx_runtime_1.jsx)("div", { className: "account-summary summary", children: (0, jsx_runtime_1.jsx)("div", { className: "summary__info m-t-20", children: "The patient has an existing account, already created below:" }) }), (0, jsx_runtime_1.jsx)("div", { className: "account-lookup-result", children: (0, jsx_runtime_1.jsx)(AccountCard_1.default, { locationId: currentLocation?.locationId, account: account, onAccountSelection: () => history.push(`${config_1.ACCOUNT_DETAIL_URL}${account.alphaeonAccountNumber}`) }) })] }) }));
}
function mapStateToProps(state) {
    return {
        approvedCreditApplication: reducer_1.selectors.approvedCreditApplication(state),
        applicationInfo: reducer_1.selectors.applicationInfo(state),
        currentLocation: reducer_1.selectors.currentLocation(state),
    };
}
const mapDispatchToProps = {};
exports.default = (0, redux_1.compose)((0, react_redux_1.connect)(mapStateToProps, mapDispatchToProps))(AccountExists);
